// This file is only used in our client-side bundle. It is used instead of the
// xmldom package, because in the browser, we have a DOMParser that's faster
// and doesn't need to be downloaded.
export const DOMParser = window.DOMParser;
